export * from "./course-info.component";
